import Vue from "vue"
import Vuex from "vuex"
import axios from 'axios'
import api from '../api/api'
import service from "../api/interceptors";

Vue.use(Vuex);

export default new Vuex.Store({
  state:{
    isLoginStatus:false
  },
  mutations:{
    changeLoginStatus(state,val){
      console.log(val);
      state.isLoginStatus = val;
      // window.sessionStorage.setItem('convId',val)
    },

  },
  actions:{

  }
})



// WEBPACK FOOTER //
// ./src/store/index.js